import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.directory',
        accordionItem: '.directory__accordion-item',
        accordionItemContent: '.directory__accordion-item-content',
        accordionItemHeadline: '.directory__accordion-item-headline',
        accordionItemLink: '.directory__accordion-item-headline-link',
        icon: '.directory__accordion-item-headline-icon-content',
    },
    classNames: {
        accordionItemContentTransition: 'directory__accordion-item-content-transition',
        accordionItemContentHidden: 'directory__accordion-item-content--hidden',
        linkIconPlain: 'icon-TickCircleForward_Circle3',
        linkIconHover: 'icon-TickCircleForward_Circle1',
    },
};

class Directory {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isAccordion = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
        this._initAccordion();

      
    }

    _getDomElements() {
        return {
            $accordionItem: this._$rootElement.find(config.selectors.accordionItem),
            $accordionItemContent: this._$rootElement.find(config.selectors.accordionItemContent),
            $accordionItemHeadline: this._$rootElement.find(config.selectors.accordionItemHeadline),
            $accordionItemLink: this._$rootElement.find(config.selectors.accordionItemLink),
            $icon: this._$rootElement.find(config.selectors.icon),
        };
    }

    _initAccordion() {
        if (Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
            this._isAccordion = false;
        }else {
            this._elements.$accordionItemContent.each((i, element) => {
                if(i===0){
                    $(element).css('height', `${$(element)[0].scrollHeight  }px`);
                    
                }
                    this._isAccordion = true;
            });
        }
       
        
    }

    _hideAll() {
        this._elements.$accordionItemContent.each((i, element) => {
            $(element).height(0);
            this._isAccordion = true;
       });
    }

    _expandAll() {
        this._elements.$accordionItemContent.each((i, element) => {
            $(element).height($(element)[0].scrollHeight);
            this._isAccordion = false;
       });
    }

    _addEventListeners() {
        const _this = this;
        const icon = this._elements.$icon;
        const item = this._elements.$accordionItem;
        const content = this._elements.$accordionItemContent

        item.mouseover((e) => {
            if ($(window).width() > Breakpoints.BREAKPOINTS.MD) {
                this._hideAll();
                $(e.currentTarget.children[1]).height($(e.currentTarget.children[1])[0].scrollHeight);
            }
        });
        
        item.mouseleave((e) => {
            if ($(window).width() > Breakpoints.BREAKPOINTS.MD) 
                $(e.currentTarget.children[1]).height(0);
        });

        $(window).on('resize', () => {
            if (!this._isAccordion && $(window).width() >= Breakpoints.BREAKPOINTS.MD) {
                this._hideAll();
            } else if (this._isAccordion && $(window).width() < Breakpoints.BREAKPOINTS.MD) {
                this._expandAll();
            }
        });

        item.on('focusin', function (e) {
            if ($(window).width() > Breakpoints.BREAKPOINTS.MD) {
                _this._hideAll();
                $(this.children[1]).height(this.children[1].scrollHeight);
            }
        });

        item.on('focusout', function (e) {
            if ($(window).width() > Breakpoints.BREAKPOINTS.MD) 
                $(this.children[1]).height(0);
        });
    }
}

moduleRegistry.registerModule('Directory', Directory);
moduleRegistry.autoApplyModule('Directory', config.selectors.root);
